<template>
    <div class="preview-holder my-4" v-if="sticker && model.product_data">
        <StickerSvg
            :sticker="sticker"
            :design="model.product_data"
            :figureHref="figureHref"
            :backgroundHref="backgroundHref"
        />
    </div>
</template>

<script>
import StickerSvg from "../sticker/StickerSvg";

export default {
    name: "StickerPreview",
    components: { StickerSvg },
    props: ["model", "background", "sample", "sticker"],
    computed: {
        figureHref() {
            const data = this.model.product_data;
            if (data.allowedFigure === false) {
                return null;
            }
            if (
                typeof data.customFileSample === "string" &&
                data.customFileSample
            ) {
                return data.customFileSample;
            }
            return data.sample && this.sample ? this.sample.image : null;
        },
        backgroundHref() {
            const data = this.model.product_data;
            if (data.allowedBackground === false) {
                return null;
            }
            if (
                typeof data.customFileBackground === "string" &&
                data.customFileBackground
            ) {
                return data.customFileBackground;
            }
            return data.background && this.background
                ? this.background.image
                : null;
        }
    }
};
</script>

<style scoped></style>
